import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\product\\ProductPageClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\ProductCard.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\styles\\product.css");
